/*eslint-disable*/
/* Jison generated parser */
let parser = {};
(function(){
/* Jison generated parser */

if ( !this.$objeq ) this.$objeq = {};
this.$objeq.parser = (function () {
var parser = {trace: function trace() { },
yy: {},
symbols_: {"error":2,"program":3,"query":4,"EOF":5,"step":6,"THEN":7,"where":8,"filter":9,"aggr":10,"expr":11,"WHERE":12,"order_by":13,"selector":14,"+":15,"-":16,"*":17,"/":18,"%":19,"AND":20,"OR":21,"EQ":22,"NEQ":23,"RE":24,"GT":25,"GTE":26,"LT":27,"LTE":28,"IN":29,"NOT":30,"(":31,")":32,"ternary":33,"func":34,"array":35,"obj":36,"NUMBER":37,"STRING":38,"TRUE":39,"FALSE":40,"NULL":41,"UNDEFINED":42,"path":43,"?":44,":":45,"IDENT":46,"expr_list":47,"[":48,"]":49,",":50,"{":51,"obj_items":52,"}":53,"obj_item":54,"obj_non_id":55,"SELECT":56,"CONTRACT":57,"EXPAND":58,"ORDER_BY":59,"order_list":60,"order_spec":61,"local_path":62,"ASC":63,"DESC":64,"AGGREGATE":65,"aggr_list":66,"arg_path":67,"ARGREF":68,".":69,"THIS":70,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",7:"THEN",12:"WHERE",15:"+",16:"-",17:"*",18:"/",19:"%",20:"AND",21:"OR",22:"EQ",23:"NEQ",24:"RE",25:"GT",26:"GTE",27:"LT",28:"LTE",29:"IN",30:"NOT",31:"(",32:")",37:"NUMBER",38:"STRING",39:"TRUE",40:"FALSE",41:"NULL",42:"UNDEFINED",44:"?",45:":",46:"IDENT",48:"[",49:"]",50:",",51:"{",53:"}",56:"SELECT",57:"CONTRACT",58:"EXPAND",59:"ORDER_BY",63:"ASC",64:"DESC",65:"AGGREGATE",68:"ARGREF",69:".",70:"THIS"},
productions_: [0,[3,2],[4,1],[4,3],[6,1],[6,2],[6,2],[6,3],[6,1],[6,2],[6,1],[8,1],[8,2],[9,1],[9,2],[9,1],[9,2],[11,3],[11,3],[11,3],[11,3],[11,3],[11,3],[11,3],[11,3],[11,3],[11,3],[11,3],[11,3],[11,3],[11,3],[11,3],[11,2],[11,2],[11,3],[11,1],[11,1],[11,1],[11,1],[11,1],[11,1],[11,1],[11,1],[11,1],[11,1],[11,1],[33,5],[34,4],[34,3],[35,3],[35,2],[47,1],[47,3],[36,3],[36,2],[52,1],[52,3],[55,1],[55,1],[55,1],[55,1],[55,1],[55,1],[54,3],[54,3],[54,1],[14,2],[14,2],[14,2],[13,2],[60,1],[60,3],[61,1],[61,2],[61,2],[10,2],[66,1],[66,3],[43,1],[43,1],[67,1],[67,3],[67,4],[62,1],[62,1],[62,3],[62,4]],
performAction: function anonymous(yytext,yyleng,yylineno,yy,yystate,$$,_$) {

var $0 = $$.length - 1;
switch (yystate) {
case 1: return $$[$0-1]; 
break;
case 2: this.$ = [$$[$0]]; 
break;
case 3: this.$ = $$[$0-2]; $$[$0-2].push($$[$0]); yy.step += 1; 
break;
case 4: this.$ = $$[$0]; 
break;
case 5: this.$ = $$[$0]; $$[$0].expr = $$[$0-1].expr; 
break;
case 6: this.$ = $$[$0-1]; $$[$0-1].aggregate = $$[$0]; 
break;
case 7: this.$ = $$[$0-1]; $$[$0-1].expr = $$[$0-2].expr; $$[$0-1].aggregate = $$[$0]; 
break;
case 8: this.$ = $$[$0]; 
break;
case 9: this.$ = $$[$0-1]; $$[$0-1].aggregate = $$[$0]; 
break;
case 10: this.$ = { aggregate: $$[$0] }; 
break;
case 11: this.$ = { expr: $$[$0] }; 
break;
case 12: this.$ = { expr: $$[$0] }; 
break;
case 13: this.$ = { order: $$[$0], sortFirst: true }; 
break;
case 14: this.$ = { order: $$[$0-1], select: $$[$0], sortFirst: true }; 
break;
case 15: this.$ = { select: $$[$0] }; 
break;
case 16: this.$ = { select: $$[$0-1], order: $$[$0] }; 
break;
case 17: this.$ = yy.node('add', $$[$0-2], $$[$0]); 
break;
case 18: this.$ = yy.node('sub', $$[$0-2], $$[$0]); 
break;
case 19: this.$ = yy.node('mul', $$[$0-2], $$[$0]); 
break;
case 20: this.$ = yy.node('div', $$[$0-2], $$[$0]); 
break;
case 21: this.$ = yy.node('mod', $$[$0-2], $$[$0]); 
break;
case 22: this.$ = yy.node('and', $$[$0-2], $$[$0]); 
break;
case 23: this.$ = yy.node('or', $$[$0-2], $$[$0]); 
break;
case 24: this.$ = yy.node('eq', $$[$0-2], $$[$0]); 
break;
case 25: this.$ = yy.node('neq', $$[$0-2], $$[$0]); 
break;
case 26: this.$ = yy.node('re', $$[$0-2], $$[$0]); 
break;
case 27: this.$ = yy.node('gt', $$[$0-2], $$[$0]); 
break;
case 28: this.$ = yy.node('gte', $$[$0-2], $$[$0]); 
break;
case 29: this.$ = yy.node('lt', $$[$0-2], $$[$0]); 
break;
case 30: this.$ = yy.node('lte', $$[$0-2], $$[$0]); 
break;
case 31: this.$ = yy.node('in', $$[$0-2], $$[$0]); 
break;
case 32: this.$ = yy.node('not', $$[$0]); 
break;
case 33: this.$ = yy.node('neg', $$[$0]); 
break;
case 34: this.$ = $$[$0-1]; 
break;
case 35: this.$ = $$[$0]; 
break;
case 36: this.$ = $$[$0]; 
break;
case 37: this.$ = $$[$0]; 
break;
case 38: this.$ = $$[$0]; 
break;
case 39: this.$ = Number(yytext); 
break;
case 40: this.$ = yytext; 
break;
case 41: this.$ = true; 
break;
case 42: this.$ = false; 
break;
case 43: this.$ = null; 
break;
case 44: this.$ = undefined; 
break;
case 45: this.$ = $$[$0]; 
break;
case 46: this.$ = yy.node('tern', $$[$0-4], $$[$0-2], $$[$0]); 
break;
case 47: this.$ = yy.node('func', $$[$0-3], $$[$0-1]); 
break;
case 48: this.$ = yy.node('func', $$[$0-2], []); 
break;
case 49: this.$ = yy.node('arr', $$[$0-1]); 
break;
case 50: this.$ = yy.node('arr', []); 
break;
case 51: this.$ = [$$[$0]]; 
break;
case 52: this.$ = $$[$0-2]; $$[$0-2].push($$[$0]); 
break;
case 53: this.$ = yy.node('obj', $$[$0-1]); 
break;
case 54: this.$ = yy.node('obj', {}); 
break;
case 55: this.$ = {}; this.$[$$[$0][0]] = $$[$0][1]; 
break;
case 56: this.$ = $$[$0-2]; this.$[$$[$0][0]] = $$[$0][1]; 
break;
case 63: this.$ = [$$[$0-2], $$[$0]]; 
break;
case 64: this.$ = [$$[$0-2], $$[$0]]; 
break;
case 65: this.$ = [$$[$0], yy.path($$[$0])]; 
break;
case 66: this.$ = yy.node('select', $$[$0]); 
break;
case 67: this.$ = yy.node('contract', $$[$0]); 
break;
case 68: this.$ = yy.node('expand', $$[$0]); 
break;
case 69: this.$ = $$[$0]; 
break;
case 70: this.$ = [$$[$0]]; 
break;
case 71: this.$ = $$[$0-2]; $$[$0-2].push($$[$0]); 
break;
case 72: this.$ = { path: $$[$0], ascending: true }; 
break;
case 73: this.$ = { path: $$[$0-1], ascending: true }; 
break;
case 74: this.$ = { path: $$[$0-1] }; 
break;
case 75: this.$ = $$[$0]; 
break;
case 76: this.$ = [$$[$0]]; 
break;
case 77: this.$ = $$[$0-2]; $$[$0-2].push($$[$0]); 
break;
case 78: this.$ = $$[$0]; 
break;
case 79: this.$ = $$[$0]; 
break;
case 80: this.$ = yy.path(Number($$[$0])-1); 
break;
case 81: this.$ = $$[$0-2]; $$[$0-2].push($$[$0]); 
break;
case 82: this.$ = $$[$0-3]; $$[$0-3].push($$[$0-1]); 
break;
case 83: this.$ = yy.path(); 
break;
case 84: this.$ = yy.path($$[$0]); 
break;
case 85: this.$ = $$[$0-2]; $$[$0-2].push($$[$0]); 
break;
case 86: this.$ = $$[$0-3]; $$[$0-3].push($$[$0-1]); 
break;
}
},
table: [{3:1,4:2,6:3,8:4,9:5,10:6,11:7,12:[1,8],13:9,14:10,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],56:[1,27],57:[1,28],58:[1,29],59:[1,26],62:34,65:[1,11],67:33,68:[1,35],70:[1,36]},{1:[3]},{5:[1,37],7:[1,38]},{5:[2,2],7:[2,2]},{5:[2,4],7:[2,4],9:39,10:40,13:9,14:10,56:[1,27],57:[1,28],58:[1,29],59:[1,26],65:[1,11]},{5:[2,8],7:[2,8],10:41,65:[1,11]},{5:[2,10],7:[2,10]},{5:[2,11],7:[2,11],15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[1,47],21:[1,48],22:[1,49],23:[1,50],24:[1,51],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[1,56],44:[1,57],56:[2,11],57:[2,11],58:[2,11],59:[2,11],65:[2,11]},{11:58,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{5:[2,13],7:[2,13],14:59,56:[1,27],57:[1,28],58:[1,29],65:[2,13]},{5:[2,15],7:[2,15],13:60,59:[1,26],65:[2,15]},{46:[1,62],66:61},{11:63,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:64,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:65,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{5:[2,35],7:[2,35],15:[2,35],16:[2,35],17:[2,35],18:[2,35],19:[2,35],20:[2,35],21:[2,35],22:[2,35],23:[2,35],24:[2,35],25:[2,35],26:[2,35],27:[2,35],28:[2,35],29:[2,35],32:[2,35],44:[2,35],45:[2,35],49:[2,35],50:[2,35],53:[2,35],56:[2,35],57:[2,35],58:[2,35],59:[2,35],65:[2,35]},{5:[2,36],7:[2,36],15:[2,36],16:[2,36],17:[2,36],18:[2,36],19:[2,36],20:[2,36],21:[2,36],22:[2,36],23:[2,36],24:[2,36],25:[2,36],26:[2,36],27:[2,36],28:[2,36],29:[2,36],32:[2,36],44:[2,36],45:[2,36],49:[2,36],50:[2,36],53:[2,36],56:[2,36],57:[2,36],58:[2,36],59:[2,36],65:[2,36]},{5:[2,37],7:[2,37],15:[2,37],16:[2,37],17:[2,37],18:[2,37],19:[2,37],20:[2,37],21:[2,37],22:[2,37],23:[2,37],24:[2,37],25:[2,37],26:[2,37],27:[2,37],28:[2,37],29:[2,37],32:[2,37],44:[2,37],45:[2,37],49:[2,37],50:[2,37],53:[2,37],56:[2,37],57:[2,37],58:[2,37],59:[2,37],65:[2,37]},{5:[2,38],7:[2,38],15:[2,38],16:[2,38],17:[2,38],18:[2,38],19:[2,38],20:[2,38],21:[2,38],22:[2,38],23:[2,38],24:[2,38],25:[2,38],26:[2,38],27:[2,38],28:[2,38],29:[2,38],32:[2,38],44:[2,38],45:[2,38],49:[2,38],50:[2,38],53:[2,38],56:[2,38],57:[2,38],58:[2,38],59:[2,38],65:[2,38]},{5:[2,39],7:[2,39],15:[2,39],16:[2,39],17:[2,39],18:[2,39],19:[2,39],20:[2,39],21:[2,39],22:[2,39],23:[2,39],24:[2,39],25:[2,39],26:[2,39],27:[2,39],28:[2,39],29:[2,39],32:[2,39],44:[2,39],45:[2,39],49:[2,39],50:[2,39],53:[2,39],56:[2,39],57:[2,39],58:[2,39],59:[2,39],65:[2,39]},{5:[2,40],7:[2,40],15:[2,40],16:[2,40],17:[2,40],18:[2,40],19:[2,40],20:[2,40],21:[2,40],22:[2,40],23:[2,40],24:[2,40],25:[2,40],26:[2,40],27:[2,40],28:[2,40],29:[2,40],32:[2,40],44:[2,40],45:[2,40],49:[2,40],50:[2,40],53:[2,40],56:[2,40],57:[2,40],58:[2,40],59:[2,40],65:[2,40]},{5:[2,41],7:[2,41],15:[2,41],16:[2,41],17:[2,41],18:[2,41],19:[2,41],20:[2,41],21:[2,41],22:[2,41],23:[2,41],24:[2,41],25:[2,41],26:[2,41],27:[2,41],28:[2,41],29:[2,41],32:[2,41],44:[2,41],45:[2,41],49:[2,41],50:[2,41],53:[2,41],56:[2,41],57:[2,41],58:[2,41],59:[2,41],65:[2,41]},{5:[2,42],7:[2,42],15:[2,42],16:[2,42],17:[2,42],18:[2,42],19:[2,42],20:[2,42],21:[2,42],22:[2,42],23:[2,42],24:[2,42],25:[2,42],26:[2,42],27:[2,42],28:[2,42],29:[2,42],32:[2,42],44:[2,42],45:[2,42],49:[2,42],50:[2,42],53:[2,42],56:[2,42],57:[2,42],58:[2,42],59:[2,42],65:[2,42]},{5:[2,43],7:[2,43],15:[2,43],16:[2,43],17:[2,43],18:[2,43],19:[2,43],20:[2,43],21:[2,43],22:[2,43],23:[2,43],24:[2,43],25:[2,43],26:[2,43],27:[2,43],28:[2,43],29:[2,43],32:[2,43],44:[2,43],45:[2,43],49:[2,43],50:[2,43],53:[2,43],56:[2,43],57:[2,43],58:[2,43],59:[2,43],65:[2,43]},{5:[2,44],7:[2,44],15:[2,44],16:[2,44],17:[2,44],18:[2,44],19:[2,44],20:[2,44],21:[2,44],22:[2,44],23:[2,44],24:[2,44],25:[2,44],26:[2,44],27:[2,44],28:[2,44],29:[2,44],32:[2,44],44:[2,44],45:[2,44],49:[2,44],50:[2,44],53:[2,44],56:[2,44],57:[2,44],58:[2,44],59:[2,44],65:[2,44]},{5:[2,45],7:[2,45],15:[2,45],16:[2,45],17:[2,45],18:[2,45],19:[2,45],20:[2,45],21:[2,45],22:[2,45],23:[2,45],24:[2,45],25:[2,45],26:[2,45],27:[2,45],28:[2,45],29:[2,45],32:[2,45],44:[2,45],45:[2,45],49:[2,45],50:[2,45],53:[2,45],56:[2,45],57:[2,45],58:[2,45],59:[2,45],65:[2,45]},{46:[1,69],60:66,61:67,62:68,70:[1,36]},{11:70,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:71,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:72,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{5:[2,84],7:[2,84],15:[2,84],16:[2,84],17:[2,84],18:[2,84],19:[2,84],20:[2,84],21:[2,84],22:[2,84],23:[2,84],24:[2,84],25:[2,84],26:[2,84],27:[2,84],28:[2,84],29:[2,84],31:[1,73],32:[2,84],44:[2,84],45:[2,84],48:[2,84],49:[2,84],50:[2,84],53:[2,84],56:[2,84],57:[2,84],58:[2,84],59:[2,84],65:[2,84],69:[2,84]},{11:76,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],47:74,48:[1,31],49:[1,75],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{37:[1,82],38:[1,83],39:[1,84],40:[1,85],41:[1,86],42:[1,87],46:[1,81],52:77,53:[1,78],54:79,55:80},{5:[2,78],7:[2,78],15:[2,78],16:[2,78],17:[2,78],18:[2,78],19:[2,78],20:[2,78],21:[2,78],22:[2,78],23:[2,78],24:[2,78],25:[2,78],26:[2,78],27:[2,78],28:[2,78],29:[2,78],32:[2,78],44:[2,78],45:[2,78],48:[1,89],49:[2,78],50:[2,78],53:[2,78],56:[2,78],57:[2,78],58:[2,78],59:[2,78],65:[2,78],69:[1,88]},{5:[2,79],7:[2,79],15:[2,79],16:[2,79],17:[2,79],18:[2,79],19:[2,79],20:[2,79],21:[2,79],22:[2,79],23:[2,79],24:[2,79],25:[2,79],26:[2,79],27:[2,79],28:[2,79],29:[2,79],32:[2,79],44:[2,79],45:[2,79],48:[1,91],49:[2,79],50:[2,79],53:[2,79],56:[2,79],57:[2,79],58:[2,79],59:[2,79],65:[2,79],69:[1,90]},{5:[2,80],7:[2,80],15:[2,80],16:[2,80],17:[2,80],18:[2,80],19:[2,80],20:[2,80],21:[2,80],22:[2,80],23:[2,80],24:[2,80],25:[2,80],26:[2,80],27:[2,80],28:[2,80],29:[2,80],32:[2,80],44:[2,80],45:[2,80],48:[2,80],49:[2,80],50:[2,80],53:[2,80],56:[2,80],57:[2,80],58:[2,80],59:[2,80],65:[2,80],69:[2,80]},{5:[2,83],7:[2,83],15:[2,83],16:[2,83],17:[2,83],18:[2,83],19:[2,83],20:[2,83],21:[2,83],22:[2,83],23:[2,83],24:[2,83],25:[2,83],26:[2,83],27:[2,83],28:[2,83],29:[2,83],32:[2,83],44:[2,83],45:[2,83],48:[2,83],49:[2,83],50:[2,83],53:[2,83],56:[2,83],57:[2,83],58:[2,83],59:[2,83],63:[2,83],64:[2,83],65:[2,83],69:[2,83]},{1:[2,1]},{6:92,8:4,9:5,10:6,11:7,12:[1,8],13:9,14:10,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],56:[1,27],57:[1,28],58:[1,29],59:[1,26],62:34,65:[1,11],67:33,68:[1,35],70:[1,36]},{5:[2,5],7:[2,5],10:93,65:[1,11]},{5:[2,6],7:[2,6]},{5:[2,9],7:[2,9]},{11:94,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:95,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:96,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:97,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:98,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:99,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:100,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:101,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:102,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:103,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:104,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:105,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:106,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:107,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:108,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:109,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{5:[2,12],7:[2,12],15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[1,47],21:[1,48],22:[1,49],23:[1,50],24:[1,51],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[1,56],44:[1,57],56:[2,12],57:[2,12],58:[2,12],59:[2,12],65:[2,12]},{5:[2,14],7:[2,14],65:[2,14]},{5:[2,16],7:[2,16],65:[2,16]},{5:[2,75],7:[2,75],50:[1,110]},{5:[2,76],7:[2,76],50:[2,76]},{5:[2,32],7:[2,32],15:[2,32],16:[2,32],17:[2,32],18:[2,32],19:[2,32],20:[2,32],21:[2,32],22:[2,32],23:[2,32],24:[2,32],25:[2,32],26:[2,32],27:[2,32],28:[2,32],29:[2,32],32:[2,32],44:[2,32],45:[2,32],49:[2,32],50:[2,32],53:[2,32],56:[2,32],57:[2,32],58:[2,32],59:[2,32],65:[2,32]},{5:[2,33],7:[2,33],15:[2,33],16:[2,33],17:[2,33],18:[2,33],19:[2,33],20:[2,33],21:[2,33],22:[2,33],23:[2,33],24:[2,33],25:[2,33],26:[2,33],27:[2,33],28:[2,33],29:[2,33],32:[2,33],44:[2,33],45:[2,33],49:[2,33],50:[2,33],53:[2,33],56:[2,33],57:[2,33],58:[2,33],59:[2,33],65:[2,33]},{15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[1,47],21:[1,48],22:[1,49],23:[1,50],24:[1,51],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[1,56],32:[1,111],44:[1,57]},{5:[2,69],7:[2,69],50:[1,112],56:[2,69],57:[2,69],58:[2,69],65:[2,69]},{5:[2,70],7:[2,70],50:[2,70],56:[2,70],57:[2,70],58:[2,70],65:[2,70]},{5:[2,72],7:[2,72],48:[1,91],50:[2,72],56:[2,72],57:[2,72],58:[2,72],63:[1,113],64:[1,114],65:[2,72],69:[1,90]},{5:[2,84],7:[2,84],48:[2,84],50:[2,84],56:[2,84],57:[2,84],58:[2,84],63:[2,84],64:[2,84],65:[2,84],69:[2,84]},{5:[2,66],7:[2,66],15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[1,47],21:[1,48],22:[1,49],23:[1,50],24:[1,51],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[1,56],44:[1,57],59:[2,66],65:[2,66]},{5:[2,67],7:[2,67],15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[1,47],21:[1,48],22:[1,49],23:[1,50],24:[1,51],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[1,56],44:[1,57],59:[2,67],65:[2,67]},{5:[2,68],7:[2,68],15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[1,47],21:[1,48],22:[1,49],23:[1,50],24:[1,51],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[1,56],44:[1,57],59:[2,68],65:[2,68]},{11:76,16:[1,13],30:[1,12],31:[1,14],32:[1,116],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],47:115,48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{49:[1,117],50:[1,118]},{5:[2,50],7:[2,50],15:[2,50],16:[2,50],17:[2,50],18:[2,50],19:[2,50],20:[2,50],21:[2,50],22:[2,50],23:[2,50],24:[2,50],25:[2,50],26:[2,50],27:[2,50],28:[2,50],29:[2,50],32:[2,50],44:[2,50],45:[2,50],49:[2,50],50:[2,50],53:[2,50],56:[2,50],57:[2,50],58:[2,50],59:[2,50],65:[2,50]},{15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[1,47],21:[1,48],22:[1,49],23:[1,50],24:[1,51],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[1,56],32:[2,51],44:[1,57],49:[2,51],50:[2,51]},{50:[1,120],53:[1,119]},{5:[2,54],7:[2,54],15:[2,54],16:[2,54],17:[2,54],18:[2,54],19:[2,54],20:[2,54],21:[2,54],22:[2,54],23:[2,54],24:[2,54],25:[2,54],26:[2,54],27:[2,54],28:[2,54],29:[2,54],32:[2,54],44:[2,54],45:[2,54],49:[2,54],50:[2,54],53:[2,54],56:[2,54],57:[2,54],58:[2,54],59:[2,54],65:[2,54]},{50:[2,55],53:[2,55]},{45:[1,121]},{45:[1,122],50:[2,65],53:[2,65]},{45:[2,57]},{45:[2,58]},{45:[2,59]},{45:[2,60]},{45:[2,61]},{45:[2,62]},{46:[1,123]},{11:124,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{46:[1,125]},{11:126,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{5:[2,3],7:[2,3]},{5:[2,7],7:[2,7]},{5:[2,17],7:[2,17],15:[2,17],16:[2,17],17:[1,44],18:[1,45],19:[1,46],20:[2,17],21:[2,17],22:[2,17],23:[2,17],24:[2,17],25:[2,17],26:[2,17],27:[2,17],28:[2,17],29:[2,17],32:[2,17],44:[2,17],45:[2,17],49:[2,17],50:[2,17],53:[2,17],56:[2,17],57:[2,17],58:[2,17],59:[2,17],65:[2,17]},{5:[2,18],7:[2,18],15:[2,18],16:[2,18],17:[1,44],18:[1,45],19:[1,46],20:[2,18],21:[2,18],22:[2,18],23:[2,18],24:[2,18],25:[2,18],26:[2,18],27:[2,18],28:[2,18],29:[2,18],32:[2,18],44:[2,18],45:[2,18],49:[2,18],50:[2,18],53:[2,18],56:[2,18],57:[2,18],58:[2,18],59:[2,18],65:[2,18]},{5:[2,19],7:[2,19],15:[2,19],16:[2,19],17:[2,19],18:[2,19],19:[2,19],20:[2,19],21:[2,19],22:[2,19],23:[2,19],24:[2,19],25:[2,19],26:[2,19],27:[2,19],28:[2,19],29:[2,19],32:[2,19],44:[2,19],45:[2,19],49:[2,19],50:[2,19],53:[2,19],56:[2,19],57:[2,19],58:[2,19],59:[2,19],65:[2,19]},{5:[2,20],7:[2,20],15:[2,20],16:[2,20],17:[2,20],18:[2,20],19:[2,20],20:[2,20],21:[2,20],22:[2,20],23:[2,20],24:[2,20],25:[2,20],26:[2,20],27:[2,20],28:[2,20],29:[2,20],32:[2,20],44:[2,20],45:[2,20],49:[2,20],50:[2,20],53:[2,20],56:[2,20],57:[2,20],58:[2,20],59:[2,20],65:[2,20]},{5:[2,21],7:[2,21],15:[2,21],16:[2,21],17:[2,21],18:[2,21],19:[2,21],20:[2,21],21:[2,21],22:[2,21],23:[2,21],24:[2,21],25:[2,21],26:[2,21],27:[2,21],28:[2,21],29:[2,21],32:[2,21],44:[2,21],45:[2,21],49:[2,21],50:[2,21],53:[2,21],56:[2,21],57:[2,21],58:[2,21],59:[2,21],65:[2,21]},{5:[2,22],7:[2,22],15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[2,22],21:[2,22],22:[1,49],23:[1,50],24:[1,51],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[1,56],32:[2,22],44:[2,22],45:[2,22],49:[2,22],50:[2,22],53:[2,22],56:[2,22],57:[2,22],58:[2,22],59:[2,22],65:[2,22]},{5:[2,23],7:[2,23],15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[1,47],21:[2,23],22:[1,49],23:[1,50],24:[1,51],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[1,56],32:[2,23],44:[2,23],45:[2,23],49:[2,23],50:[2,23],53:[2,23],56:[2,23],57:[2,23],58:[2,23],59:[2,23],65:[2,23]},{5:[2,24],7:[2,24],15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[2,24],21:[2,24],22:[2,24],23:[2,24],24:[2,24],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[2,24],32:[2,24],44:[2,24],45:[2,24],49:[2,24],50:[2,24],53:[2,24],56:[2,24],57:[2,24],58:[2,24],59:[2,24],65:[2,24]},{5:[2,25],7:[2,25],15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[2,25],21:[2,25],22:[2,25],23:[2,25],24:[2,25],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[2,25],32:[2,25],44:[2,25],45:[2,25],49:[2,25],50:[2,25],53:[2,25],56:[2,25],57:[2,25],58:[2,25],59:[2,25],65:[2,25]},{5:[2,26],7:[2,26],15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[2,26],21:[2,26],22:[2,26],23:[2,26],24:[2,26],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[2,26],32:[2,26],44:[2,26],45:[2,26],49:[2,26],50:[2,26],53:[2,26],56:[2,26],57:[2,26],58:[2,26],59:[2,26],65:[2,26]},{5:[2,27],7:[2,27],15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[2,27],21:[2,27],22:[2,27],23:[2,27],24:[2,27],25:[2,27],26:[2,27],27:[2,27],28:[2,27],29:[2,27],32:[2,27],44:[2,27],45:[2,27],49:[2,27],50:[2,27],53:[2,27],56:[2,27],57:[2,27],58:[2,27],59:[2,27],65:[2,27]},{5:[2,28],7:[2,28],15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[2,28],21:[2,28],22:[2,28],23:[2,28],24:[2,28],25:[2,28],26:[2,28],27:[2,28],28:[2,28],29:[2,28],32:[2,28],44:[2,28],45:[2,28],49:[2,28],50:[2,28],53:[2,28],56:[2,28],57:[2,28],58:[2,28],59:[2,28],65:[2,28]},{5:[2,29],7:[2,29],15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[2,29],21:[2,29],22:[2,29],23:[2,29],24:[2,29],25:[2,29],26:[2,29],27:[2,29],28:[2,29],29:[2,29],32:[2,29],44:[2,29],45:[2,29],49:[2,29],50:[2,29],53:[2,29],56:[2,29],57:[2,29],58:[2,29],59:[2,29],65:[2,29]},{5:[2,30],7:[2,30],15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[2,30],21:[2,30],22:[2,30],23:[2,30],24:[2,30],25:[2,30],26:[2,30],27:[2,30],28:[2,30],29:[2,30],32:[2,30],44:[2,30],45:[2,30],49:[2,30],50:[2,30],53:[2,30],56:[2,30],57:[2,30],58:[2,30],59:[2,30],65:[2,30]},{5:[2,31],7:[2,31],15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[2,31],21:[2,31],22:[2,31],23:[2,31],24:[2,31],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[2,31],32:[2,31],44:[2,31],45:[2,31],49:[2,31],50:[2,31],53:[2,31],56:[2,31],57:[2,31],58:[2,31],59:[2,31],65:[2,31]},{15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[1,47],21:[1,48],22:[1,49],23:[1,50],24:[1,51],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[1,56],44:[1,57],45:[1,127]},{46:[1,128]},{5:[2,34],7:[2,34],15:[2,34],16:[2,34],17:[2,34],18:[2,34],19:[2,34],20:[2,34],21:[2,34],22:[2,34],23:[2,34],24:[2,34],25:[2,34],26:[2,34],27:[2,34],28:[2,34],29:[2,34],32:[2,34],44:[2,34],45:[2,34],49:[2,34],50:[2,34],53:[2,34],56:[2,34],57:[2,34],58:[2,34],59:[2,34],65:[2,34]},{46:[1,69],61:129,62:68,70:[1,36]},{5:[2,73],7:[2,73],50:[2,73],56:[2,73],57:[2,73],58:[2,73],65:[2,73]},{5:[2,74],7:[2,74],50:[2,74],56:[2,74],57:[2,74],58:[2,74],65:[2,74]},{32:[1,130],50:[1,118]},{5:[2,48],7:[2,48],15:[2,48],16:[2,48],17:[2,48],18:[2,48],19:[2,48],20:[2,48],21:[2,48],22:[2,48],23:[2,48],24:[2,48],25:[2,48],26:[2,48],27:[2,48],28:[2,48],29:[2,48],32:[2,48],44:[2,48],45:[2,48],49:[2,48],50:[2,48],53:[2,48],56:[2,48],57:[2,48],58:[2,48],59:[2,48],65:[2,48]},{5:[2,49],7:[2,49],15:[2,49],16:[2,49],17:[2,49],18:[2,49],19:[2,49],20:[2,49],21:[2,49],22:[2,49],23:[2,49],24:[2,49],25:[2,49],26:[2,49],27:[2,49],28:[2,49],29:[2,49],32:[2,49],44:[2,49],45:[2,49],49:[2,49],50:[2,49],53:[2,49],56:[2,49],57:[2,49],58:[2,49],59:[2,49],65:[2,49]},{11:131,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{5:[2,53],7:[2,53],15:[2,53],16:[2,53],17:[2,53],18:[2,53],19:[2,53],20:[2,53],21:[2,53],22:[2,53],23:[2,53],24:[2,53],25:[2,53],26:[2,53],27:[2,53],28:[2,53],29:[2,53],32:[2,53],44:[2,53],45:[2,53],49:[2,53],50:[2,53],53:[2,53],56:[2,53],57:[2,53],58:[2,53],59:[2,53],65:[2,53]},{37:[1,82],38:[1,83],39:[1,84],40:[1,85],41:[1,86],42:[1,87],46:[1,81],54:132,55:80},{11:133,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{11:134,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{5:[2,81],7:[2,81],15:[2,81],16:[2,81],17:[2,81],18:[2,81],19:[2,81],20:[2,81],21:[2,81],22:[2,81],23:[2,81],24:[2,81],25:[2,81],26:[2,81],27:[2,81],28:[2,81],29:[2,81],32:[2,81],44:[2,81],45:[2,81],48:[2,81],49:[2,81],50:[2,81],53:[2,81],56:[2,81],57:[2,81],58:[2,81],59:[2,81],65:[2,81],69:[2,81]},{15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[1,47],21:[1,48],22:[1,49],23:[1,50],24:[1,51],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[1,56],44:[1,57],49:[1,135]},{5:[2,85],7:[2,85],15:[2,85],16:[2,85],17:[2,85],18:[2,85],19:[2,85],20:[2,85],21:[2,85],22:[2,85],23:[2,85],24:[2,85],25:[2,85],26:[2,85],27:[2,85],28:[2,85],29:[2,85],32:[2,85],44:[2,85],45:[2,85],48:[2,85],49:[2,85],50:[2,85],53:[2,85],56:[2,85],57:[2,85],58:[2,85],59:[2,85],63:[2,85],64:[2,85],65:[2,85],69:[2,85]},{15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[1,47],21:[1,48],22:[1,49],23:[1,50],24:[1,51],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[1,56],44:[1,57],49:[1,136]},{11:137,16:[1,13],30:[1,12],31:[1,14],33:15,34:16,35:17,36:18,37:[1,19],38:[1,20],39:[1,21],40:[1,22],41:[1,23],42:[1,24],43:25,46:[1,30],48:[1,31],51:[1,32],62:34,67:33,68:[1,35],70:[1,36]},{5:[2,77],7:[2,77],50:[2,77]},{5:[2,71],7:[2,71],50:[2,71],56:[2,71],57:[2,71],58:[2,71],65:[2,71]},{5:[2,47],7:[2,47],15:[2,47],16:[2,47],17:[2,47],18:[2,47],19:[2,47],20:[2,47],21:[2,47],22:[2,47],23:[2,47],24:[2,47],25:[2,47],26:[2,47],27:[2,47],28:[2,47],29:[2,47],32:[2,47],44:[2,47],45:[2,47],49:[2,47],50:[2,47],53:[2,47],56:[2,47],57:[2,47],58:[2,47],59:[2,47],65:[2,47]},{15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[1,47],21:[1,48],22:[1,49],23:[1,50],24:[1,51],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[1,56],32:[2,52],44:[1,57],49:[2,52],50:[2,52]},{50:[2,56],53:[2,56]},{15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[1,47],21:[1,48],22:[1,49],23:[1,50],24:[1,51],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[1,56],44:[1,57],50:[2,63],53:[2,63]},{15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[1,47],21:[1,48],22:[1,49],23:[1,50],24:[1,51],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[1,56],44:[1,57],50:[2,64],53:[2,64]},{5:[2,82],7:[2,82],15:[2,82],16:[2,82],17:[2,82],18:[2,82],19:[2,82],20:[2,82],21:[2,82],22:[2,82],23:[2,82],24:[2,82],25:[2,82],26:[2,82],27:[2,82],28:[2,82],29:[2,82],32:[2,82],44:[2,82],45:[2,82],48:[2,82],49:[2,82],50:[2,82],53:[2,82],56:[2,82],57:[2,82],58:[2,82],59:[2,82],65:[2,82],69:[2,82]},{5:[2,86],7:[2,86],15:[2,86],16:[2,86],17:[2,86],18:[2,86],19:[2,86],20:[2,86],21:[2,86],22:[2,86],23:[2,86],24:[2,86],25:[2,86],26:[2,86],27:[2,86],28:[2,86],29:[2,86],32:[2,86],44:[2,86],45:[2,86],48:[2,86],49:[2,86],50:[2,86],53:[2,86],56:[2,86],57:[2,86],58:[2,86],59:[2,86],63:[2,86],64:[2,86],65:[2,86],69:[2,86]},{5:[2,46],7:[2,46],15:[1,42],16:[1,43],17:[1,44],18:[1,45],19:[1,46],20:[1,47],21:[1,48],22:[1,49],23:[1,50],24:[1,51],25:[1,52],26:[1,53],27:[1,54],28:[1,55],29:[1,56],32:[2,46],44:[2,46],45:[2,46],49:[2,46],50:[2,46],53:[2,46],56:[2,46],57:[2,46],58:[2,46],59:[2,46],65:[2,46]}],
defaultActions: {37:[2,1],82:[2,57],83:[2,58],84:[2,59],85:[2,60],86:[2,61],87:[2,62]},
parseError: function parseError(str, hash) {
    throw new Error(str);
},
parse: function parse(input) {
    var self = this, stack = [0], vstack = [null], lstack = [], table = this.table, yytext = "", yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    this.lexer.setInput(input);
    this.lexer.yy = this.yy;
    this.yy.lexer = this.lexer;
    this.yy.parser = this;
    if (typeof this.lexer.yylloc == "undefined")
        this.lexer.yylloc = {};
    var yyloc = this.lexer.yylloc;
    lstack.push(yyloc);
    var ranges = this.lexer.options && this.lexer.options.ranges;
    if (typeof this.yy.parseError === "function")
        this.parseError = this.yy.parseError;
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    function lex() {
        var token;
        token = self.lexer.lex() || 1;
        if (typeof token !== "number") {
            token = self.symbols_[token] || token;
        }
        return token;
    }
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == "undefined") {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
        if (typeof action === "undefined" || !action.length || !action[0]) {
            var errStr = "";
            if (!recovering) {
                expected = [];
                for (p in table[state])
                    if (this.terminals_[p] && p > 2) {
                        expected.push("'" + this.terminals_[p] + "'");
                    }
                if (this.lexer.showPosition) {
                    errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
                } else {
                    errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1?"end of input":"'" + (this.terminals_[symbol] || symbol) + "'");
                }
                this.parseError(errStr, {text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected});
            }
        }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(this.lexer.yytext);
            lstack.push(this.lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = this.lexer.yyleng;
                yytext = this.lexer.yytext;
                yylineno = this.lexer.yylineno;
                yyloc = this.lexer.yylloc;
                if (recovering > 0)
                    recovering--;
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {first_line: lstack[lstack.length - (len || 1)].first_line, last_line: lstack[lstack.length - 1].last_line, first_column: lstack[lstack.length - (len || 1)].first_column, last_column: lstack[lstack.length - 1].last_column};
            if (ranges) {
                yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
            }
            r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
            if (typeof r !== "undefined") {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}
};
undefined/* Jison generated lexer */
var lexer = (function(){
var lexer = ({EOF:1,
parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },
setInput:function (input) {
        this._input = input;
        this._more = this._less = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {first_line:1,first_column:0,last_line:1,last_column:0};
        if (this.options.ranges) this.yylloc.range = [0,0];
        this.offset = 0;
        return this;
    },
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) this.yylloc.range[1]++;

        this._input = this._input.slice(1);
        return ch;
    },
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length-len-1);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length-1);
        this.matched = this.matched.substr(0, this.matched.length-1);

        if (lines.length-1) this.yylineno -= lines.length-1;
        var r = this.yylloc.range;

        this.yylloc = {first_line: this.yylloc.first_line,
          last_line: this.yylineno+1,
          first_column: this.yylloc.first_column,
          last_column: lines ?
              (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length:
              this.yylloc.first_column - len
          };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        return this;
    },
more:function () {
        this._more = true;
        return this;
    },
less:function (n) {
        this.unput(this.match.slice(n));
    },
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20)+(next.length > 20 ? '...':'')).replace(/\n/g, "");
    },
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c+"^";
    },
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) this.done = true;

        var token,
            match,
            tempMatch,
            index,
            col,
            lines;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i=0;i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (!this.options.flex) break;
            }
        }
        if (match) {
            lines = match[0].match(/(?:\r\n?|\n).*/g);
            if (lines) this.yylineno += lines.length;
            this.yylloc = {first_line: this.yylloc.last_line,
                           last_line: this.yylineno+1,
                           first_column: this.yylloc.last_column,
                           last_column: lines ? lines[lines.length-1].length-lines[lines.length-1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length};
            this.yytext += match[0];
            this.match += match[0];
            this.matches = match;
            this.yyleng = this.yytext.length;
            if (this.options.ranges) {
                this.yylloc.range = [this.offset, this.offset += this.yyleng];
            }
            this._more = false;
            this._input = this._input.slice(match[0].length);
            this.matched += match[0];
            token = this.performAction.call(this, this.yy, this, rules[index],this.conditionStack[this.conditionStack.length-1]);
            if (this.done && this._input) this.done = false;
            if (token) return token;
            else return;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line '+(this.yylineno+1)+'. Unrecognized text.\n'+this.showPosition(),
                    {text: "", token: null, line: this.yylineno});
        }
    },
lex:function lex() {
        var r = this.next();
        if (typeof r !== 'undefined') {
            return r;
        } else {
            return this.lex();
        }
    },
begin:function begin(condition) {
        this.conditionStack.push(condition);
    },
popState:function popState() {
        return this.conditionStack.pop();
    },
_currentRules:function _currentRules() {
        return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules;
    },
topState:function () {
        return this.conditionStack[this.conditionStack.length-2];
    },
pushState:function begin(condition) {
        this.begin(condition);
    }});
lexer.options = {"case-insensitive":true};
lexer.performAction = function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {

var YYSTATE=YY_START
switch($avoiding_name_collisions) {
case 0:return 37;
break;
case 1:
  yy_.yytext = yy_.yytext.substr(1,yy_.yyleng-2); return 38;

break;
case 2:
  yy_.yytext = yy_.yytext.substr(1,yy_.yyleng-2); return 38;

break;
case 3:
  yy_.yytext = yy_.yytext.substr(1); return 68;

break;
case 4:/* skip whitespace */
break;
case 5:return 42;
break;
case 6:return 41;
break;
case 7:return 39;
break;
case 8:return 40;
break;
case 9:return 12;
break;
case 10:return 56;
break;
case 11:return 57;
break;
case 12:return 58;
break;
case 13:return 65;
break;
case 14:return 59;
break;
case 15:return 7;
break;
case 16:return 70;
break;
case 17:return 63;
break;
case 18:return 64;
break;
case 19:return 20;
break;
case 20:return 21;
break;
case 21:return 30;
break;
case 22:return "IN";
break;
case 23:return 22;
break;
case 24:return 23;
break;
case 25:return 24;
break;
case 26:return 28;
break;
case 27:return 26;
break;
case 28:return 20;
break;
case 29:return 21;
break;
case 30:return 56;
break;
case 31:return 57;
break;
case 32:return 58;
break;
case 33:return 65;
break;
case 34:return 30;
break;
case 35:return 27;
break;
case 36:return 25;
break;
case 37:return 7;
break;
case 38:return 31;
break;
case 39:return 32;
break;
case 40:return 48;
break;
case 41:return 49;
break;
case 42:return 51;
break;
case 43:return 53;
break;
case 44:return 44;
break;
case 45:return 45;
break;
case 46:return 69;
break;
case 47:return 50;
break;
case 48:return 15;
break;
case 49:return 16;
break;
case 50:return 17;
break;
case 51:return 18;
break;
case 52:return 19;
break;
case 53:return 46;
break;
case 54:return 5;
break;
case 55:return 'INVALID';
break;
}
};
lexer.rules = [/^(?:((?:[0-9]|[1-9][0-9]+))((?:\.[0-9]+))?((?:[eE][-+]?[0-9]+))?\b)/i,/^(?:"(\\x[a-fA-F0-9]{2}|\\u[a-fA-F0-9]{4}|\\[^xu]|[^"(\\)\n])*")/i,/^(?:'(\\['bfvnrt/(\\)]|\\u[a-fA-F0-9]{4}|[^'(\\)])*')/i,/^(?:%[1-9][0-9]*)/i,/^(?:([\s])+)/i,/^(?:undefined\b)/i,/^(?:null\b)/i,/^(?:true\b)/i,/^(?:false\b)/i,/^(?:where\b)/i,/^(?:select\b)/i,/^(?:contract\b)/i,/^(?:expand\b)/i,/^(?:aggregate\b)/i,/^(?:(order([\s])+)?by\b)/i,/^(?:then\b)/i,/^(?:this\b)/i,/^(?:asc\b)/i,/^(?:desc\b)/i,/^(?:and\b)/i,/^(?:or\b)/i,/^(?:not\b)/i,/^(?:in\b)/i,/^(?:==)/i,/^(?:!=)/i,/^(?:=~)/i,/^(?:<=)/i,/^(?:>=)/i,/^(?:&&)/i,/^(?:\|\|)/i,/^(?:->)/i,/^(?::>)/i,/^(?:<:)/i,/^(?::=)/i,/^(?:!)/i,/^(?:<)/i,/^(?:>)/i,/^(?:\|)/i,/^(?:\()/i,/^(?:\))/i,/^(?:\[)/i,/^(?:\])/i,/^(?:\{)/i,/^(?:\})/i,/^(?:\?)/i,/^(?::)/i,/^(?:\.)/i,/^(?:,)/i,/^(?:\+)/i,/^(?:-)/i,/^(?:\*)/i,/^(?:\/)/i,/^(?:%)/i,/^(?:[A-Za-z_$][A-Za-z_$0-9]+)/i,/^(?:$)/i,/^(?:.)/i];
lexer.conditions = {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55],"inclusive":true}};
return lexer;})()
parser.lexer = lexer;
function Parser () { this.yy = {}; }Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();
}).apply(parser)

export const Parser = parser.$objeq.parser.Parser;